// Unfortunately this is currently the only way to render our component as it should (because it needs information from each HOC)
// It uses 2 different HOC's that pass their (renamed) injected Props to their corresponding child components
// For easier readability, the components are listed in the order they are render (most upper component is render first)
// If you ever have to debug this - Have fun 🧓🏼

import React from "react"
import { connectHitsPerPage, connectPagination } from "react-instantsearch-dom"

export const hitsPerPageConfig = {
	defaultRefinement: 16,
	items: [
		{ value: 16, label: "16" },
		{ value: 32, label: "32" },
		{ value: 48, label: "48" },
	],
}

const getNumberOfFirstProductOnCurrentPage = (
	hitsPerPage: number,
	currentPageNumber: number,
	totalNumberOfResults: number,
) => {
	if (totalNumberOfResults < hitsPerPage) return 1

	return hitsPerPage * (currentPageNumber - 1) + 1
}

const getNumberOfLastProductOnCurrentPage = (
	hitsPerPage: number,
	currentPageNumber: number,
	totalNumberOfResults: number,
) => {
	const numberOfLastProductOnCurrentPage = currentPageNumber * hitsPerPage

	return numberOfLastProductOnCurrentPage > totalNumberOfResults
		? totalNumberOfResults
		: numberOfLastProductOnCurrentPage
}

// Parent Component 🧓🏼 (Level 1)
const HitsPerPageAggregator = connectHitsPerPage(function HitsPerPageAggregatorChild({
	currentRefinement: hitsPerPage,
	totalNumberOfResults,
}: HitsPerPageAggregatorProps) {
	return (
		<NumberOfResultsConsumer
			hitsPerPage={hitsPerPage}
			totalNumberOfResults={totalNumberOfResults}
		/>
	)
})

interface HitsPerPageAggregatorProps {
	/**
	 * Hits per page
	 */
	currentRefinement: number
	totalNumberOfResults: number
}

// Child Component 👶🏻 (Level 2)
// This is the actual the component that renders the aggregated information
const NumberOfResultsConsumer = connectPagination(function NumberOfResultsConsumerChild({
	currentRefinement: currentPageNumber,
	hitsPerPage,
	totalNumberOfResults,
}: HitsPerPageProvidedProps) {
	const numberOfFirstProductOnCurrentPage = getNumberOfFirstProductOnCurrentPage(
		hitsPerPage,
		currentPageNumber,
		totalNumberOfResults,
	)
	const numberOfLastProductOnCurrentPage = getNumberOfLastProductOnCurrentPage(
		hitsPerPage,
		currentPageNumber,
		totalNumberOfResults,
	)

	return (
		<span style={{ color: "#505e5f" }}>
			{numberOfFirstProductOnCurrentPage} bis {numberOfLastProductOnCurrentPage} von{" "}
			{totalNumberOfResults}
		</span>
	)
})

interface HitsPerPageProvidedProps {
	/**
	 * Current page
	 */
	currentRefinement: number
	hitsPerPage: number
	totalNumberOfResults: number
}

const NumberOfResults = (props: Props) => (
	<HitsPerPageAggregator {...hitsPerPageConfig} {...props} />
)

interface Props {
	totalNumberOfResults: number
}

export default NumberOfResults
